import { ValidationErr } from "../Validations/ValidationError";
import { AxiosResponse } from "axios";

import toastr from "toastr";

export async function Controller<T>(
    exec: Promise<AxiosResponse<T>>,
    successMessage?: string | ((res: T) => string)
) {
    return exec
        .then((res) => {
            const responseMessage: string | undefined = (res.data as any)
                .message;
            const responseMessageVendas: string | undefined = (
                res.data as any
            )[0]?.Message;

            if (responseMessageVendas) {
                toastr.success(responseMessageVendas);
            } else if (responseMessage || successMessage) {
                const message =
                    responseMessage ??
                    (typeof successMessage === "string"
                        ? successMessage
                        : successMessage?.(res.data));

                if (message) toastr.success(message);
            }

            return res.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}
